import {
  Basketball3x3EventDetailId,
  Event,
  relationStatuses,
  SportDetailInputType,
} from '@collector/sportsapi-client-legacy'
import { SelectOption } from '@mobile/components/Select/types/SelectOption'
import { CollectorSport } from '@mobile/reusables/classes/CollectorSport'

import {
  EventPreparationEventDetail,
  EventPreparationEventDetailsSportFactory,
} from './types'
import { getDetailName, getDetailSelectItems } from './utils'

export function eventPreparationEventDetailsBasketball3x3Factory(
  event: Event,
  sport: CollectorSport,
): EventPreparationEventDetailsSportFactory {
  function getDetails(): EventPreparationEventDetail[] {
    return [
      {
        name: 'Relation status',
        fieldName: 'relation_status',
        type: SportDetailInputType.Select,
        items: relationStatuses,
      },
      {
        id: Basketball3x3EventDetailId.PeriodLength,
        name: getDetailName(sport, Basketball3x3EventDetailId.PeriodLength),
        type: SportDetailInputType.Number,
      },
      {
        id: Basketball3x3EventDetailId.PossessionTimeLimit,
        name: getDetailName(
          sport,
          Basketball3x3EventDetailId.PossessionTimeLimit,
        ),
        type: SportDetailInputType.Number,
      },
      {
        id: Basketball3x3EventDetailId.TimerDirection,
        name: getDetailName(sport, Basketball3x3EventDetailId.TimerDirection),
        type: SportDetailInputType.Select,
        items: getDetailSelectItems(
          event,
          sport,
          Basketball3x3EventDetailId.TimerDirection,
        ),
      },
      {
        id: Basketball3x3EventDetailId.TossWinner,
        name: getDetailName(sport, Basketball3x3EventDetailId.TossWinner),
        type: SportDetailInputType.Select,
        items: getDetailSelectItems(
          event,
          sport,
          Basketball3x3EventDetailId.TossWinner,
        ),
      },
      {
        name: 'Event status',
        fieldName: 'status_id',
        type: SportDetailInputType.Select,
        items: getEventStatusesSelectItems(),
      },
    ]
  }

  function getEventStatusesSelectItems(): SelectOption[] {
    return sport.sportsAPIEntity.statuses.map((status) => ({
      name: status.name,
      value: status.id,
    }))
  }

  return { getDetails }
}
